import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { colors } from '../../theme/colors'

interface TestimonialProps {
  comment: string
  customerName: string
  customerLocation: string
}

const Testimonial: FC<TestimonialProps> = ({ comment, customerName, customerLocation }) => (
  <div className="bg-green-100 p-6 rounded-[12px] md:rounded-[16px] flex flex-col justify-between">
    <Typography variant="p1" sx={{ color: colors.Green[900] }} className="pb-4 hidden md:block">
      &ldquo;{comment}&rdquo;
    </Typography>
    <Typography variant="p2" sx={{ color: colors.Green[900] }} className="pb-4 md:hidden">
      &ldquo;{comment}&rdquo;
    </Typography>
    <div>
      <Typography variant="p2" sx={{ color: colors.Green[900] }} className="hidden md:block">
        <b>{customerName}</b>
      </Typography>
      <Typography variant="p3" sx={{ color: colors.Green[900] }} className="md:hidden">
        <b>{customerName}</b>
      </Typography>
      <Typography variant="p2" sx={{ color: colors.Green[900] }} className="hidden md:block">
        {customerLocation}
      </Typography>
      <Typography variant="p3" sx={{ color: colors.Green[900] }} className="md:hidden">
        {customerLocation}
      </Typography>
    </div>
  </div>
)

export default Testimonial
